<template>
  <!-- 派单原因 -->
  <el-dialog
    title="派单原因"
    :visible.sync="assignReasonVisible"
    :close-on-click-modal="false"
    width="500px"
    v-loading="dialogLoading"
    :element-loading-background="loadingBackground"
    custom-class="custom-dialog"
    :before-close="handleClose"
    :modal-append-to-body="false"
    @open="openDialog"
  >
    <el-form
      label-width="200px"
      :rules="rules"
      ref="assignReason"

    >
      <!-- :rules="formRule" -->
      <el-form-item label="派单原因:" label-width="60" prop="assignReason">
        <e6-vr-select
          v-model="assignReason"
          :data="assignReasonList"
          :props="{
            id: 'codeValue',
            label: 'codeName'
          }"
          style="width: 60%"
          placeholder="派单原因"
          title="派单原因"
          clearable
        ></e6-vr-select>
      </el-form-item>

    </el-form>
    <div class="dialog-footer" slot="footer">
      <el-button class="cancel" @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { findDownList, bindAssignReason } from "@/api";
import base from "@/mixins/base";
import { printError } from "@/utils/util";
export default {
  name: "assignReasonDialog",
  components: {},
  data() {
    return {
      dialogLoading: false,
      assignReasonList: [],
      assignReason:"",
      firstReasonList: [],
      secondReasonList: [],
      rules: {
        firstReason: [
          {
            required: true,
            message: "请选择一级超期原因",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  mixins: [base],
  props: ["itemIdList", "assignReasonVisible"],
  computed: {},
  watch: {},
  methods: {
    openDialog() {
      this.getSelectList("assignReason");
      this.$nextTick(() => {
        this.$refs.assignReason.clearValidate();
      });
    },

    async getSelectList(key) {
      try {
        let res = await findDownList([key]);
        this.assignReasonList = res.data[key];
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    handleSubmit() {
      this.submitReq();
    /*  this.$refs.assignReason.validate(valid => {
        if (valid) {

        }
      });*/
    },
    async submitReq() {
      try {
        this.loading = true;
        let res = await bindAssignReason({
          assignReason: this.assignReason,
          itemIdList: this.itemIdList
        });
        if (res.code == "OK") {
          this.$message.success("操作成功");
          this.handleClose();
          this.$emit("refresh");
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.assignReason = "";
      this.$emit("handleClose", "assignReasonVisible");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped lang="scss">
/deep/.custom-dialog {
  .el-dialog__body {
    padding: 15px 20px;
    box-sizing: border-box;

    .el-form {
      margin-top: 15px;
      .el-textarea {
        width: 350px;
      }
    }
  }
}
</style>
